import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button, Modal, Image } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import AvbVideo from '@/assets/video/AVB_TSN.mp4';
import { useTranslation } from 'react-i18next';

const Content2 = (props) => {
  const { dataSource, ...restProps } = props;
  const { t, i18n } = useTranslation();
  const { titleWrapper, page, block } = dataSource;
  const [childWrapper, setChildWrapper] = useState(dataSource.childWrapper);
  const [activeProduction, setActiveProduction] = useState('');
  const [activeProductionChildren, setActiveProductionChildren] = useState('');
  const [videoShow, setVideoShow] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    setChildWrapper(dataSource.childWrapper);
    clickItem(0);
  }, [dataSource]);

  function clickItem(index) {
    const newChildWrapper = [...childWrapper.children];
    newChildWrapper.forEach((item, i) => {
      item.active = i === index;
    });
    setChildWrapper({ ...childWrapper, children: newChildWrapper });
    setActiveProduction({ ...childWrapper.children[index] });
    setActiveProductionChildren({ ...childWrapper.children[index].children.children });
  }

  const closeView = () => {
    setPlaying(false);
    setVideoShow(false);
  };
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content2" style={{ background: '#fff' }}>
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Row {...childWrapper}>
            <Col md={10} xs={24}>
              {
                childWrapper.children.map((item, i) => {
                  return (
                    <Button type={item.active ? 'primary' : ''}
                            key={i.toString()}
                            onClick={() => clickItem(i)}>
                      {t(item.title)}
                    </Button>
                  );
                })
              }
              {
                !!activeProduction.className && (
                  <div className={activeProduction.className}>
                    <h1 className={activeProductionChildren[0].className}>
                      {t(activeProductionChildren[0].children)}
                    </h1>
                    <h2 className={activeProductionChildren[1].className}>
                      {t(activeProductionChildren[1].children)}
                    </h2>
                    <div className={activeProductionChildren[2].className}>
                      <p>{t(activeProductionChildren[2].title)}</p>
                      <div dangerouslySetInnerHTML={{ __html: t(activeProductionChildren[2].children) }}></div>
                    </div>
                    {
                      !!activeProductionChildren[3] && (
                        <Button
                          className={activeProductionChildren[3].className}
                          shape="round"
                          icon={<PlayCircleOutlined />}
                          iconPosition={'end'}
                          onClick={() => setVideoShow(true)}
                        >
                          {t('product.basic.videoIntroduction')}
                        </Button>
                      )
                    }
                  </div>
                )
              }
            </Col>
            {
              !!activeProduction.className && (
                <Col md={14} xs={24}>
                  <Image
                    src={require(`@/assets/production/basic/${activeProduction.img}${i18n.language === 'en' ? '_en' : ''}.png`)} />
                </Col>
              )}
          </Row>
        </div>
      </div>
      {
        !!activeProductionChildren[3] && (
          <Modal
            title=""
            open={videoShow}
            footer={null}
            closable={false}
            afterClose={() => setPlaying(false)}
            onCancel={closeView}
            wrapClassName={'video-modal'}
          >
            <ReactPlayer
              url={AvbVideo}
              controls={true}
              width={'100%'}
              height={'100%'}
              playing={playing}
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
            />
          </Modal>
        )
      }
    </div>
  );
};

export default Content2;
